import { BroadcastChannel } from 'broadcast-channel';
import { extractAliasValueFromProcessObject } from 'exacta-material-react/lib/src';
import { ExactaAPI } from 'exacta-material-react/lib/src/api/exactaapi';
import { createAddRequest } from 'exacta-material-react/lib/src/helpers/request';
import {
    editProcessSuccess_AC, moveEmbeddedProcess_AC, updateEmbeddedProcessDocument_AC
} from 'exacta-material-react/lib/src/store/actions/process';
import { processDataSelector } from 'exacta-material-react/lib/src/store/selectors/process';
import {
    ActionEmitPayload, ControlActions, ControlEmitPayload, EmitPayload, Executor
} from 'executor';
import { LogLevel } from 'executor/build/main/lib/Logger';
import isElectron from 'is-electron';
import { get } from 'lodash';
import queryString from 'query-string';
import { AnyAction } from 'redux';
import { eventChannel } from 'redux-saga';
import {
    actionChannel, call, delay, put, select, take, takeEvery, takeLatest
} from 'redux-saga/effects';

import MenuItems from '../../containers/Catiz3/MenuItems.json';
import { menuItems as HermesysMenu } from '../../containers/Hermesys/main/TopMenuBar';
import { ComposedActions, CustomAction } from '../../helpers/actions';
import Communicator from '../../helpers/communication-adapter';
import {
    ClearCheckPointAction, CommunicationMessageTypes, config, ExecutorActions, ExecutorActionSymbol,
    LessonState, PolygonTypes, S80ExecutorActions
} from '../../helpers/constants';
import { clickButton, clickButtonObj } from '../../helpers/dom-utils';
import createLogger, { LoggerColumns } from '../../helpers/logger';
import {
    arrayToObjParams, arrayToObjTransform, catiz_menu_bfs, convertIdToCssSelectorId, getArgVal
} from '../../helpers/utils';
import { Action } from '../../types/actions-types';
import {
    IActionForMainMonitorMessage, IControlMessage, IExecutorActionMessage, IInputEventMessage,
    LessonControlTypes
} from '../../types/communicator-types';
import { fileResourceUrl } from '../../utils/urlUtils';
import actionService from '../actions.service';
import * as execActions from '../actions/executor.actions';
import * as touchPanelActions from '../actions/s80_touchpanel.actions';

const logger = createLogger('executor.saga.ts').tags(['saga']);
let exactaAPI;
const executorChannel = 'EXECUTOR_CHANNEL';
const broadCastChannelString = 'exacta-nots';
let isMasterMonitor = false;

let communicatorInputEvents: Communicator<IInputEventMessage>;
let communicatorExecutorActions: Communicator<IExecutorActionMessage>;
let communicatorActionForMainMonitor: Communicator<IActionForMainMonitorMessage>;

let execActionChannel: any;
let localLessonStatus: string = '';
let localLessonContext: any = {};

const NO_PAUSE_ACTIONS = [
  ExecutorActions.UserSetWindowAttribute,
  ExecutorActions.SystemSetWindowAttributes,
  ExecutorActions.SystemSetWindowCountdownAttribute,
  ExecutorActions.HideWindow,
  ExecutorActions.ShowNoGoZone,
  ExecutorActions.SetTrackAtPosition,
  ExecutorActions.TouchPanelShowHidePanels,
  ExecutorActions.TouchPanelShowTextInTPTA,
  ExecutorActions.DisplayTrackThroughTrajectory,
  ExecutorActions.ShowCoverageArea,
  ExecutorActions.SystemDisplayTrackThroughTrajectory,
  ExecutorActions.SetActiveRole,

  // S80 Actions
  S80ExecutorActions.SetActiveMonitor,
  S80ExecutorActions.SignOnRole,
  S80ExecutorActions.ShowTSDGeneralInformationArea,
  S80ExecutorActions.SetMonitorLayout,
  S80ExecutorActions.SetMFCCRoles,
  S80ExecutorActions.SetWindowDataItems,
  S80ExecutorActions.SystemDeleteWindowDataItem,
  S80ExecutorActions.SystemUpdateWindowDataItems,
  S80ExecutorActions.SystemUnselectWindowDataItems,
  // S80ExecutorActions.ShowTutorialInTutorialArea,
  S80ExecutorActions.SystemShowTutorialArea,
  S80ExecutorActions.SystemHideTutorialArea,
  ExecutorActions.ShowAlert,
  ExecutorActions.SystemRemoveAlert,
  ExecutorActions.SystemClearAllAlerts,
  S80ExecutorActions.SystemShowTouchPanelVabArray,
  S80ExecutorActions.SetValueInMonitorField,
];

const NO_PAUSE_NO_DELAY_ACTIONS = [
  ExecutorActions.SystemConnectTrackGroup,
  ExecutorActions.SystemDisconnectTrackGroup,
  execActions.types.CLEAR_CHECKPOINT,
  execActions.types.REVERT_TO_CHECKPOINT,
  S80ExecutorActions.SignOffRole,
  S80ExecutorActions.SignOffAllRoles,
  // S80ExecutorActions.SetMap,
  S80ExecutorActions.SystemSetTouchPanelToggleVariable,
  ExecutorActions.SetImageInTacsit,
  ExecutorActions.Pass,
  ExecutorActions.SystemPlaceTrackSymbolAtPosition,
  ExecutorActions.SystemPlaceWayPoint,
  ExecutorActions.SystemRemoveWaypoint,
  ExecutorActions.SystemPlaceAreaCircle,
  ExecutorActions.SystemRemoveCircle,
  ExecutorActions.SystemPlacePolyline,
  ExecutorActions.SystemRemovePolyline,
  ExecutorActions.SystemPlaceAreaPolygon,
  ExecutorActions.SystemRemovePolygon,
  ExecutorActions.SystemPlaceAreaCircularSector,
  ExecutorActions.SystemRemoveCircularSector,
  ExecutorActions.SetWaypointsFromResource,
  ExecutorActions.SystemPlacePoint,
  S80ExecutorActions.SystemSetLowerMonitorLED,
  S80ExecutorActions.SystemShowMob,
  S80ExecutorActions.SystemHideMob,
  ExecutorActions.SystemChangeTrackSymbol,
  ExecutorActions.SystemDrawTrackCenteredCircle,
  ExecutorActions.SystemDrawTrackRectangle,

  ExecutorActions.SystemRemoveTrack,

  // S80 Actions to set monitor fields
  S80ExecutorActions.SystemSetMonitorLayout,
  S80ExecutorActions.SystemSetSonarWorkModeArea,
  S80ExecutorActions.SystemSetSonarCursorInfoArea,
  S80ExecutorActions.SystemSetSonarShipInfoArea,
  S80ExecutorActions.SystemSetSonarAudioInfoArea,
  S80ExecutorActions.SystemSetSonarAuxInfoArea,
  S80ExecutorActions.SystemSetTacticalAuxInfoAreaNavaid,
  S80ExecutorActions.SystemSetTacticalAuxInfoAreaMob,
  S80ExecutorActions.SystemSetTacticalAuxInfoAreaPeriscope,
  S80ExecutorActions.SystemSetTacticalSpareAreaPeriscope,
  S80ExecutorActions.SystemSetTacticalCSRAInfoArea,
  S80ExecutorActions.SystemSetTacticalSpareAreaRadarLink,
  S80ExecutorActions.SystemSetSonarCSRAInfoArea,
  S80ExecutorActions.SystemSetSystemLayoutCSRAInfoArea,
  S80ExecutorActions.SystemSetSystemLayoutShipInfoArea,
  S80ExecutorActions.SystemSetWeaponCSRAInfoArea,
  S80ExecutorActions.SystemSetWeaponShipInfoArea,
  S80ExecutorActions.SystemSetObtShipInfoArea,
  S80ExecutorActions.SystemSetLinkLayoutCSRAInfoArea,
  S80ExecutorActions.SystemSetLinkLayoutLinkStatusArea,
  S80ExecutorActions.SystemSetTacticalShipInfoArea,
  S80ExecutorActions.SystemSetRoleInfoArea,
  ExecutorActions.SystemUpdatePrimaryHookProperties,
  ExecutorActions.SystemUpdateSecondaryHookProperties,
  S80ExecutorActions.SystemHideTacsitGeneralInfoArea,
  S80ExecutorActions.SystemShowTacsitGeneralInfoArea,
  S80ExecutorActions.SystemHideTacsitBallTabPosition,
  S80ExecutorActions.SystemShowTacsitBallTabPosition,
];

type NlmsAttemptStatus = 'completed' | 'aborted';

interface NlmsIntegrationParams {
  attemptId: string;
  apiUrl: string;
  authToken: string;
}

const NLMS_ATTEMPT_ID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

let nlmsIntegrationParams: NlmsIntegrationParams | null = null;
let nlmsAttemptInitialized = false;
let nlmsAttemptFinished = false;
let nlmsAttemptStarted = false;

const getSingleParam = (
  value: string | string[] | null | undefined
): string | null => {
  if (!value) {
    return null;
  }
  if (Array.isArray(value)) {
    return value[0] ?? null;
  }
  return value;
};

function* startNlmsAttemptIfPresent(startContext?: {
  enrollId?: string | string[];
  unit?: string | string[];
  subjectId?: string | string[];
  mode?: string | string[];
  attemptType?: string | string[];
}) {
  ensureNlmsInitialization();
  if (!nlmsIntegrationParams) {
    console.log('[NLMS] No integration params. Skipping NLMS begin hook.');
    return;
  }

  if (nlmsAttemptStarted) {
    console.log('[NLMS] Attempt already marked as started. Skipping /begin call.');
    return;
  }

  const attemptType = getSingleParam(startContext?.attemptType);
  if (attemptType === 'exam') {
    nlmsAttemptStarted = true;
    nlmsAttemptFinished = false;
    return;
  }

  const { attemptId, apiUrl, authToken } = nlmsIntegrationParams;
  if (!attemptId) {
    console.warn('[NLMS] Cannot begin attempt without attemptId.');
    nlmsAttemptStarted = true;
    nlmsAttemptFinished = false;
    return;
  }

  try {
    const response: Response = yield call(() =>
      fetch(`${apiUrl}/lesson-attempts/${attemptId}/begin`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
    );

    if (!response.ok) {
      let errorBody: any = null;
      try {
        errorBody = yield call(() => response.json());
      } catch (_error) {
        // ignore parse errors
      }
      console.error('[NLMS] Failed to begin lesson attempt.', {
        status: response.status,
        statusText: response.statusText,
        detail: errorBody?.detail,
      });
    } else {
      let responseBody: any = null;
      try {
        responseBody = yield call(() => response.json());
      } catch (_error) {
        // ignore parse errors
      }

      if (responseBody?.lesson_attempt_id) {
        nlmsIntegrationParams = {
          ...nlmsIntegrationParams,
          attemptId: responseBody.lesson_attempt_id,
        };
        console.log('[NLMS] Lesson attempt marked in progress.', {
          attemptId: responseBody.lesson_attempt_id,
          startedAt: responseBody.started_at,
          status: responseBody.status,
        });
      } else {
        console.log('[NLMS] Lesson attempt begin acknowledged.');
      }
    }
  } catch (error) {
    console.error('[NLMS] Error beginning lesson attempt.', error);
  } finally {
    nlmsAttemptStarted = true;
    nlmsAttemptFinished = false;
  }
}

const isValidUuid = (value: string) => NLMS_ATTEMPT_ID_REGEX.test(value);

const isValidApiUrl = (value: string) => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_error) {
    return false;
  }
};

const extractNlmsParamsFromUrl = (): NlmsIntegrationParams | null => {
  const parsedParams = queryString.parse(window.location.search);
  const attemptId = getSingleParam(parsedParams.attemptId);
  const apiUrl = getSingleParam(parsedParams.apiUrl);
  const authToken = getSingleParam(parsedParams.authToken);

  if (!attemptId || !apiUrl || !authToken) {
    return null;
  }

  if (!isValidUuid(attemptId)) {
    console.error(
      '[NLMS] Invalid attemptId detected in URL. Skipping NLMS integration.'
    );
    return null;
  }

  if (!isValidApiUrl(apiUrl)) {
    console.error(
      '[NLMS] Invalid apiUrl detected in URL. Skipping NLMS integration.'
    );
    return null;
  }

  return {
    attemptId,
    apiUrl,
    authToken,
  };
};

const ensureNlmsInitialization = () => {
  if (nlmsAttemptInitialized) {
    return;
  }

  nlmsIntegrationParams = extractNlmsParamsFromUrl();
  nlmsAttemptInitialized = true;

  if (nlmsIntegrationParams) {
    console.log(
      `[NLMS] Integration enabled for attempt ${nlmsIntegrationParams.attemptId}`
    );
  } else {
    console.warn('[NLMS] NLMS parameters not found. Integration disabled.');
  }
};

const buildLessonLogBlob = (): Blob | null => {
  try {
    const logEntries = Executor.getLog(LogLevel.LMS);
    if (Array.isArray(logEntries) && logEntries.length > 0) {
      const serializedLog = JSON.stringify(logEntries);
      return new Blob([serializedLog], { type: 'application/json' });
    }
  } catch (error) {
    console.error('[NLMS] Failed to serialize lesson log for NLMS.', error);
  }
  return null;
};

function* finishNlmsAttempt(attemptStatus: NlmsAttemptStatus) {
  ensureNlmsInitialization();
  if (!nlmsIntegrationParams) {
    return;
  }

  if (nlmsAttemptFinished) {
    console.warn('[NLMS] Attempt already finished. Skipping duplicate finish.');
    return;
  }

  const { attemptId, apiUrl, authToken } = nlmsIntegrationParams;

  const formData = new FormData();
  formData.append('attempt_type', attemptStatus);

  if (attemptStatus === 'completed') {
    const lessonLogBlob = buildLessonLogBlob();
    if (lessonLogBlob) {
      formData.append('lesson_log', lessonLogBlob, 'lesson.log');
    } else {
      console.warn('[NLMS] Lesson log unavailable. Continuing without log.');
    }
  }

  try {
    const response: Response = yield call(() =>
      fetch(`${apiUrl}/lesson-attempts/${attemptId}/finish`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: formData,
      })
    );

    if (!response.ok) {
      let errorBody: any = null;
      try {
        errorBody = yield call(() => response.json());
      } catch (_error) {
        // ignore parsing error
      }
      console.error('[NLMS] Failed to finish lesson attempt.', {
        status: response.status,
        statusText: response.statusText,
        detail: errorBody?.detail,
      });
      return;
    }

    let responseBody: any = null;
    try {
      responseBody = yield call(() => response.json());
    } catch (_error) {
      // ignore parsing error
    }

    if (responseBody) {
      console.log('[NLMS] Lesson attempt finished.', {
        attemptId,
        status: responseBody.status,
        finishedAt: responseBody.finished_at,
        timeSpentSeconds: responseBody.time_spent_seconds,
      });
    } else {
      console.log('[NLMS] Lesson attempt finished.', {
        attemptId,
        status: attemptStatus,
      });
    }

    nlmsAttemptFinished = true;
  } catch (error) {
    console.error('[NLMS] Error finishing lesson attempt.', error);
  }
}

const isDemoMode = () => {
  return localLessonContext && localLessonContext.mode === 'demo';
};

function validate(payload: { name: string; parameters: any }) {
  logger
    .columns([LoggerColumns.EXECUTOR])
    .log(`validate ${payload.name}`, { ...payload });
  Executor.validate(payload);
}

const reportError = (
  emitter,
  reason = `Error!! Invalid lesson definition.`
) => {
  setTimeout(() => {
    emitter(execActions.showHint_Ac(reason));
  });
};

function doStartExecutor(trainingUnit: any, context: any) {
  return eventChannel((executionChannelEmitter: any) => {
    try {
      const migrated = Executor.migrate(trainingUnit);
      if (!migrated.migrate) {
        // migration failed
        console.log(`Migration failed`, migrated);
        reportError(executionChannelEmitter);
        return () => {};
      } else {
        const loadResult = Executor.load(migrated.lesson);
        if (!loadResult.loaded) {
          console.error(`cannot load lesson`, loadResult, migrated.lesson);
          reportError(executionChannelEmitter);
          return () => {};
        }
      }
      isMasterMonitor = true;
    } catch (err) {
      console.log(err);
      reportError(executionChannelEmitter);
      return () => {};
    }
    const callback = (arg: EmitPayload) => {
      console.log('callback result', {
        arg,
      });
      if (arg.type === 'ACTION') {
        const action = arg as ActionEmitPayload;
        logger
          .columns([LoggerColumns.EXECUTOR])
          .log(`${action.type} ${action.payload.name}`, arg.payload);

        executionChannelEmitter(
          execActions.createExecutorAction(
            action.payload.name,
            action.payload.parameters
          )
        );
      } else {
        const controlAction = arg as ControlEmitPayload;
        logger
          .columns([LoggerColumns.EXECUTOR])
          .log(
            `${controlAction.type} ${controlAction.payload.control}`,
            arg.payload
          );

        switch (controlAction.payload.control) {
          case ControlActions.GuardViolation:
          case ControlActions.Error:
            executionChannelEmitter(
              execActions.showHint_Ac(controlAction.payload.message)
            );
            break;
          case ControlActions.MaxErrorsReached:
            executionChannelEmitter(
              execActions.endOfLesson_AC(controlAction.payload.message)
            );
            break;
          case ControlActions.LessonComplete:
            console.log('lesson complete recieved');
            executionChannelEmitter(execActions.readyToEndOfLesson_AC());
            break;
          case ControlActions.InvalidActionInput:
            console.log('InvalidActionInput', controlAction);
            executionChannelEmitter(
              execActions.showHint_Ac('You have performed an incorrect action ')
            );
            if (localLessonContext && localLessonContext.mode !== 'demo') {
              executionChannelEmitter(execActions.revertToCheckPoint_Ac());
            }
            break;
          case ControlActions.Delay:
            executionChannelEmitter(
              execActions.executorDelay_AC(controlAction.payload.message.delay)
            );
            break;
          case ControlActions.ActionValid:
            const action = controlAction.payload.message.action;
            if (localLessonContext && localLessonContext.mode !== 'demo') {
              setTimeout(() => {
                executionChannelEmitter(execActions.clearCheckPoint_Ac());
              });
              if (ClearCheckPointAction.some((a: any) => a === action.name)) {
              }
            }
        }
      }
    };
    Executor.onActionEmit(callback);
    // Debug execution log on console, enable or disable as fit.
    Executor.onLog(logExecutorResultsToConsole);
    Executor.start(context.role, context.mode);

    return () => {
      // Stop the executor
    };
  });
}

const ColorDict = {
  debug: 'orange',
  info: 'gray',
  lesson: 'blue',
  error: 'red',
};

function logExecutorResultsToConsole(payload: any) {
  const colorSelected = ColorDict[payload.level] || 'red';
  console.group(
    `[executor] %cLogLevel: ${payload.level}`,
    `color: ${colorSelected}`
  );
  console.log(payload);
  console.groupEnd();
}

function doTabCommunication() {
  return eventChannel((mainReduxChannelEmitter: any) => {
    // mainReduxChannelEmitter is not exactly the main redux emitter
    // but we won't wait for TAKE_NEXT on this channel so the actions are immediately put in
    // main redux action stream.
    // Network should be ready by this point.
    communicatorInputEvents = new Communicator<IInputEventMessage>(
      CommunicationMessageTypes.InputEvent
    );
    communicatorExecutorActions = new Communicator<IExecutorActionMessage>(
      CommunicationMessageTypes.ExecutorAction
    );
    communicatorActionForMainMonitor =
      new Communicator<IActionForMainMonitorMessage>(
        CommunicationMessageTypes.ActionForMainMonitor
      );
    communicatorExecutorActions.receiveMessage((msg) => {
      // an action given by executor, put it in redux as redux action
      // this is a slave monitor and hence all executor actions from this stream
      // need to be put in the main redux channel
      console.log('got message type ExecutorAction', msg);
      const { type, payload, actionFromExecutor } = msg;
      mainReduxChannelEmitter({
        type,
        payload: {
          ...payload,
          [Symbol.for(ExecutorActionSymbol)]: actionFromExecutor,
        },
      });
    });
    communicatorActionForMainMonitor.receiveMessage((msg) => {
      // an action happened in the slave monitor, if you are the master monitor
      // you need to dispatch it as your own action
      if (isMasterMonitor) {
        mainReduxChannelEmitter({ ...msg });
      }
    });
    communicatorInputEvents.receiveMessage((msg) => {
      // an input event to the executor happened in a slave window, if you are
      // the master window, you need to send it to the executor
      if (isMasterMonitor) {
        console.log('exector run', msg);
        validate({
          name: msg.name,
          parameters: msg.parameters,
        });
      }
    });

    return () => {
      // Stop the broadcast
    };
  });
}

function* waitForNetworkToBeReady() {
  const maxTries = 30; // we wait for a total of 30 sec
  let noOfRetries = 1;
  while (!Communicator.isReady && noOfRetries < maxTries) {
    console.warn('Waiting for network (probably socket)');
    yield delay(1000);
    noOfRetries++;
  }
  if (!Communicator.isReady) {
    console.error('Network not ready in time');
    throw new Error('Network not ready in time');
  }
  return true;
}

function* startTabCommunication() {
  yield waitForNetworkToBeReady();
  const channel = yield call(doTabCommunication);
  const context = yield select((state: any) => state.executor.context);
  localLessonContext = context;
  try {
    while (true) {
      const action = yield take(channel);
      yield put(action);
    }
  } finally {
    console.log('tab communication terminated');
  }
}

function sendLessonCompleteToElectron() {
  logger.log('lesson complete will be sent now', {
    isElectron: isElectron(),
    windowNotsElectron: window.NotsElectron,
  });
  if (isElectron() && window.NotsElectron) {
    // tell electron that the lesson is complete
    window.NotsElectron.send('lesson-complete', {});
  }
}

function* waitForAnimationAndCompleteLesson(
  actionPayload: Action<{ reason: string }>
) {
  sendLessonCompleteToElectron();
  if (isMasterMonitor) {
    const { payload } = actionPayload;
    do {
      const { pendingAnimations, pendingNonBlockingAnimations } = yield select(
        (state: any) => state.executor
      );
      if (pendingAnimations <= 0 && pendingNonBlockingAnimations <= 0) {
        yield put(execActions.endOfLesson_AC(payload.reason));
        return;
      }
      yield delay(200);
    } while (true);
  }
}

export function* startExecutor({
  payload,
  type,
}: {
  payload: any;
  type: string;
}) {
  const { trainingUnit, context } = payload;
  const channel = yield call(doStartExecutor, trainingUnit, context);
  localLessonContext = context;
  try {
    while (true) {
      const action = yield take(channel);
      console.log('dispatched action', action);
      // Put items in the 'EXECUTOR_CHANNEL' the actions will then be consumed
      // in a serial fashion by the actionChannel
      yield put(execActionChannel, action);
    }
  } finally {
    console.log('executor terminated');
  }
}

export function* onMultimediaOkClicked(action) {
  const isBroadCasted = action && action.payload && action.payload.broadcasted;
  if (!isBroadCasted) {
    yield sendToAllMonitorsSaga({
      ...action,
      payload: {},
    });
  }

  if (isMasterMonitor) {
    yield takeNextActionImmediately(action);
  }
}

export function* startExecutorChannel() {
  execActionChannel = yield actionChannel(executorChannel);
  while (true) {
    const action = yield take(execActionChannel);
    console.log('debug', action);
    // Put the executor action in the main redux action stream
    // so that all slave monitors can consume it and put it in their own
    // redux, Symbols are not serializable so we need add it as a property
    // which is served by actionFromExecutor
    communicatorExecutorActions.postMessage({
      type: action.type,
      payload: action.payload,
      actionFromExecutor: action.payload?.[Symbol.for(ExecutorActionSymbol)],
    });
    yield put(action);
    // Take the next action that the executor has given or wait for one.
    yield take(execActions.types.TAKE_NEXT_ACTION);

    let lessonStatus;
    lessonStatus = yield select((state: any) => state.executor.status);
    while (lessonStatus === LessonState.PAUSED) {
      console.log('waiting for unpause');
      yield delay(100);
      lessonStatus = yield select((state: any) => state.executor.status);
    }
    if (lessonStatus === LessonState.STOPPED) {
      return;
    }
  }
}

function* takeNextActionImmediately({ type }: AnyAction) {
  yield put(execActions.takeNextActionAC(`${type} NO_PAUSE_NO_DELAY`));
}

function* takeNextActionWatcher({ type }: AnyAction) {
  yield readyToTakeNextAction(`${type} NO_PAUSE`);
}

function* readyToTakeNextAction(reason: string) {
  do {
    yield delay(config.NextActionDelay);
    const pendingAnimations = yield select(
      (state: any) => state.executor.pendingAnimations
    );
    if (pendingAnimations <= 0) {
      yield put(execActions.takeNextActionAC(reason));
      return;
    }
  } while (true);
}

function reEmitInMainMonitor<T>(action: CustomAction<T>, payload) {
  if (isMasterMonitor) {
    validate({ name: action.id, parameters: payload.actionPayload });
  } else {
    communicatorActionForMainMonitor.postMessage({
      type: action.uiAction,
      payload,
      actionFromExecutor: false,
    });
  }
}

function* doTouchPanelButtonClick({
  payload,
  type,
}: {
  payload: any;
  type: any;
}) {
  const { actionPayload } = payload;
  const params = arrayToObjParams(actionPayload);
  clickButton('root', params['TouchPanelButtonClickedId']);
}

function* showButtonIndicator(windowId: string, buttonId: string) {
  const pointerBtn: any = document.querySelector(`#${windowId} #${buttonId}`);
  console.log('showbutton indicator', pointerBtn, windowId, buttonId);
  if (pointerBtn) {
    console.log('pointer btn');
    const rect = pointerBtn.getBoundingClientRect();
    const x = rect.x + rect.width / 2 - 20;
    const y = rect.y - 10;
    yield put(execActions.showIndicator_AC(x, y));
    yield delay(2000);
  }
}

function* showMapPointIndicator(pointId: string, internalAction: any) {
  const point: any = document.querySelector(`#_${pointId}`);

  if (point) {
    console.log('pointer btn');
    const rect = point.getBoundingClientRect();
    const x = rect.x + rect.width / 2 - 20;
    const y = rect.y - 45;
    yield put(execActions.showIndicator_AC(x, y));
    yield delay(2000);
    yield put(internalAction);
    yield takeNextActionInMainMonitor('pushPrimaryOrSecondary demo');
  }
}

function* pressGeneralButton(
  buttonId: string,
  calculateHeight: boolean = false
) {
  const button: any = document.querySelector(`#${buttonId}`);
  console.log('clicking on the button', button, 'with id', buttonId);
  if (button) {
    const rect = button.getBoundingClientRect();
    const x = rect.x + rect.width / 2 - 20;
    // const y = rect.y - rect.height / 2;
    const y = rect.y - (calculateHeight ? rect.height / 2 : 20);
    yield put(execActions.showIndicator_AC(x, y));
    yield delay(2000);
    yield call(clickButtonObj, button);
  }
}

function* doButtonClick({ payload, type }: { payload: any; type: any }) {
  const { actionPayload } = payload;
  const { window, id: buttonId } = actionPayload;
  yield call(showButtonIndicator, window, buttonId);
  clickButton(window, buttonId);
}

function* doTabClick({ payload, type }: { payload: any; type: any }) {
  const { actionPayload } = payload;
  const { window, tabId } = actionPayload;
  if (isDemoMode()) {
    yield call(showButtonIndicator, window, tabId);
    clickButton(window, tabId);
  } else {
    // This is necessary because in manual mode when the executor gives the ok, the action is dispached again
    // This is essential to set the store to a commited state in some other basic functions like UserSetWindowAttribute
    yield readyToTakeNextAction(`doTabClick`);
  }
}

function* onUserTabClicked({ payload, type }: { payload: any; type: any }) {
  const { windowId, tabId } = payload;
  if (isDemoMode()) {
    yield takeNextActionInMainMonitor(`userTabClicked demo`);
  } else {
    // send to executor
    sendToExecutorInMainMonitor(ComposedActions.SetWindowActiveTab.id, [
      { name: 'window', value: windowId },
      { name: 'tabId', value: tabId },
    ]);
  }
}

export type PayloadToExecutorPayload = (payload: any) => any;
export type ActionPayloadToButtonClick = (actionPayload: any) => any;

export function GenericButtonClickBehaviour<T>({
  actionType,
  payloadTransformer,
  identifierPathsInExecPayload,
  actionPayloadTransformer,
  canSkipValidation = false,
}: {
  actionType: CustomAction<T>;
  payloadTransformer: PayloadToExecutorPayload;
  identifierPathsInExecPayload?: { window: string; buttonId: string };
  actionPayloadTransformer?: ActionPayloadToButtonClick;
  canSkipValidation?: boolean;
}) {
  return function* ({ payload, type }: { payload: any; type: any }) {
    if (isDemoMode()) {
      if (type === actionType.id) {
        //demo mode action in demo mode proceed to click the button
        yield doButtonClickGeneric({
          payload: {
            actionPayload: identifierPathsInExecPayload
              ? {
                  window: get(payload, identifierPathsInExecPayload.window),
                  id: get(payload, identifierPathsInExecPayload.buttonId),
                }
              : actionPayloadTransformer &&
                actionPayloadTransformer(payload.actionPayload),
          },
        });
      } else {
        // demo mode button click completed take next action
        yield takeNextActionInMainMonitor(`${type} demo`);
      }
    } else {
      //user mode action triggered send for evaluation
      !canSkipValidation &&
        sendToExecutorInMainMonitor(actionType.id, payloadTransformer(payload));
    }
  };
}

export const selectUnselectPayloadTransformer = (actionPayload: any) => {
  const { window, ...rest } = actionPayload;
  const key = Object.keys(rest)[0];
  const value = rest[key][0];
  const { rowNumber, ...otherValues } = value;
  const colId = Object.keys(otherValues)
    .find((item) => item.includes('_selected'))
    ?.split('_selected')[0];
  return {
    window,
    id: colId ? `${key}_${rowNumber}_${colId}` : `${key}_row_${rowNumber}`,
  };
};

const onSelectWindowDataItem = (actionType) =>
  GenericButtonClickBehaviour({
    actionType: actionType,
    payloadTransformer: (payload: any) => payload.actionPayload,
    actionPayloadTransformer: (actionPayload: any) =>
      selectUnselectPayloadTransformer(actionPayload),
  });

const onWindowButtonClickedNew = GenericButtonClickBehaviour({
  actionType: ComposedActions.PushWindowButton,
  payloadTransformer: (payload: any) => [
    { name: 'window', value: payload.windowId },
    { name: 'id', value: payload.buttonId },
  ],
  identifierPathsInExecPayload: {
    window: 'actionPayload.window',
    buttonId: 'actionPayload.id',
  },
});

const onTabClickNew = GenericButtonClickBehaviour({
  actionType: ComposedActions.SetWindowActiveTab,
  payloadTransformer: (payload: any) => [
    { name: 'window', value: payload.windowId },
    { name: 'tabId', value: payload.tabId },
  ],
  identifierPathsInExecPayload: {
    window: 'actionPayload.window',
    buttonId: 'actionPayload.tabId',
  },
});

const onAlertButtonClick = GenericButtonClickBehaviour({
  actionType: ComposedActions.ClickButtonOnReviewAlertsPanel,
  payloadTransformer: (payload: any) => [{ name: 'id', value: payload.id }],
  identifierPathsInExecPayload: {
    buttonId: 'actionPayload.id',
    window: 'actionPayload.window',
  },
});

const onGeneralButtonClick = GenericButtonClickBehaviour({
  actionType: ComposedActions.PressGeneralButtonSwitch,
  payloadTransformer: (payload: any) => [
    { name: 'id', value: payload.id },
    { name: 'isActive', value: payload.isActive },
  ],
  identifierPathsInExecPayload: {
    buttonId: 'actionPayload.id',
    window: 'actionPayload.window',
  },
});

function* onUIBTCapture({ payload, type }: { payload: any; type: string }) {
  const { buttonId, captureAttributes, windowId } = payload;
  if (isDemoMode()) {
    yield readyToTakeNextAction(`UIBTCapture demo`);
  } else {
    console.log('lets send bt stuff to executor');
    sendToExecutorInMainMonitor(S80ExecutorActions.PushWindowButtonCaptureBT, [
      { name: 'window', value: windowId },
      { name: 'captureBT', value: captureAttributes },
      { name: 'id', value: buttonId },
    ]);
  }
}

function* takeNextActionInMainMonitor(reason: string) {
  if (isMasterMonitor) {
    yield readyToTakeNextAction(reason);
  } else {
    communicatorActionForMainMonitor.postMessage({
      type: execActions.types.TAKE_NEXT_ACTION,
      payload: {
        meta: reason,
      },
      actionFromExecutor: false,
    });
  }
}

const onToggleClick = GenericButtonClickBehaviour({
  actionType: ComposedActions.PushWindowToggleButton,
  payloadTransformer: (payload: any) => [
    { name: 'window', value: payload.windowId },
    { name: payload.key, value: payload.value },
  ],
  identifierPathsInExecPayload: {
    buttonId: 'actionPayload.id',
    window: 'actionPayload.window',
  },
});

function* toggleButtonClick({ payload, type }: { payload: any; type: any }) {
  const { windowId, key, value } = payload;
  const context = yield select((state: any) => state.executor.context);
  if (isDemoMode()) {
    if (type === ComposedActions.PushWindowToggleButton.id) {
      const { actionPayload } = payload;
      const modifiedPayload = actionPayload.map((item: any) => {
        //Because the payload here will contain the id in the key making the payload compatible for doButtonClick
        if (item.name !== 'window' && item.name !== 'label') {
          return {
            name: 'id',
            value: item.name,
          };
        }
        return item;
      });
      yield doButtonClick({
        type,
        payload: { actionPayload: modifiedPayload },
      });
    } else {
      yield takeNextActionInMainMonitor(`pushWindowToggleButton demo`);
    }
  } else {
    sendToExecutorInMainMonitor(ComposedActions.PushWindowToggleButton.id, [
      { name: 'window', value: windowId },
      { name: key, value },
    ]);
  }
}

function* updateAnimationsInMainMonitor({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  if (!isMasterMonitor) {
    communicatorActionForMainMonitor.postMessage({
      type,
      payload,
      actionFromExecutor: false,
    });
  }
}

function* onWindowButtonClicked({
  payload,
  type,
}: {
  payload: any;
  type: any;
}) {
  const { windowId, buttonId } = payload;
  const context = yield select((state: any) => state.executor.context);
  if (isDemoMode()) {
    if (type === ComposedActions.PushWindowButton.id) {
      yield doButtonClick({ type, payload });
    } else {
      yield takeNextActionInMainMonitor(`windowButtonClicked demo`);
    }
  } else {
    // send to executor
    sendToExecutorInMainMonitor(ComposedActions.PushWindowButton.id, [
      { name: 'window', value: windowId },
      { name: 'id', value: buttonId },
    ]);
  }
}

const onWindowToggleButtonClickedNew = (actionType) =>
  GenericButtonClickBehaviour({
    actionType: actionType,
    payloadTransformer: (payload: any) => [
      { name: 'window', value: payload.windowId },
      { name: payload.key, value: payload.value },
    ],
    actionPayloadTransformer: (actionPayload: any) => {
      const { window, label, ...rest } = actionPayload;
      return {
        window,
        id: Object.keys(rest)[0],
      };
    },
  });

function* uiWindowToggleButtonClick({
  payload,
  type,
}: {
  payload: any;
  type: any;
}) {
  const { windowId, key, value } = payload;
  console.log('window toggle click');
  if (isDemoMode()) {
    yield takeNextActionInMainMonitor(`windowToggleButtonClick demo`);
  } else {
    // send to executor

    const actionType =
      type === ComposedActions.PushWindowTextToggleButton.uiAction
        ? ComposedActions.PushWindowTextToggleButton.id
        : ComposedActions.PushWindowToggleButton.id;

    sendToExecutorInMainMonitor(actionType, [
      { name: 'window', value: windowId },
      { name: key, value },
    ]);
  }
}

function* onWindowShow() {
  if (isDemoMode()) {
    yield delay(config.WindowShowDelay);
    yield readyToTakeNextAction(`windowShow demo`);
  } else {
    yield readyToTakeNextAction(`windowShow`);
  }
}

function* doSendToParent({ payload, type }: { payload: any; type: string }) {
  if (isMasterMonitor) {
    yield put({
      ...payload,
    });
  } else {
    communicatorActionForMainMonitor.postMessage(payload);
  }
}

function sendToExecutorInMainMonitor(eventType: any, payload: any) {
  const transformedPayload = arrayToObjTransform(payload);
  if (isMasterMonitor) {
    validate({
      name: eventType,
      parameters: transformedPayload,
    });
  } else {
    communicatorInputEvents.postMessage({
      name: eventType,
      parameters: transformedPayload,
    });
  }
}

function dispatchInMainMonitor(eventType: any, payload: any) {
  if (isMasterMonitor) {
    validate({
      name: eventType,
      parameters: payload,
    });
  } else {
    communicatorExecutorActions.postMessage({
      type: eventType,
      payload: {
        actionPayload: payload,
      },
      actionFromExecutor: false,
    });
  }
}

function* onTouchPanelButtonClicked({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  // const context = yield select((state) => state.executor.context);
  const context = localLessonContext;
  if (context && context.mode !== 'demo') {
    if (isMasterMonitor) {
      validate({
        name: ExecutorActions.TouchPanelButtonOperation,
        parameters: {
          ...(payload.touchPanelId && { TouchPanelId: payload.touchPanelId }),
          TouchPanelButtonClickedId: payload.buttonId,
        },
      });
    }
  } else {
    yield takeNextActionInMainMonitor(`demo touchpanelbuttonclicked`);
  }
  // This action would never occur in the slave monitor as the action is always sent to the main monitor
  // in slave monitor if this action appears because of broadcast, it has to be ignored.
}

function* onEndLesson({ type, payload }) {
  const message = payload.message || 'Lesson Completed';
  yield put(execActions.showHintNoActionButtons_Ac(message));
  yield put(execActions.finishAttemptAC({}));
  sendLessonCompleteToElectron();
  yield delay(2000);
  const controlCommunicator = new Communicator<IControlMessage>(
    CommunicationMessageTypes.ControlMessage
  );
  controlCommunicator.postMessage({
    lessonState: LessonState.STOPPED,
    type: LessonControlTypes.LessonStateControl,
  });
  yield put(execActions.executorStatusUpdateAC(LessonState.STOPPED));
}

function* finishAttempt({ type, payload }) {
  console.log('finishing attempt');
  const { abort = false } = payload;
  const attemptStatus: NlmsAttemptStatus = abort ? 'aborted' : 'completed';
  console.log('[NLMS] finishAttempt saga dispatching finishNlmsAttempt', {
    attemptStatus,
  });
  yield call(finishNlmsAttempt as any, attemptStatus);
  const { enrollId, attemptType } = queryString.parse(window.location.search);
  if (enrollId) {
    const processData: any = yield select(processDataSelector);
    const enrollmentProcess = processData.CourseEnrolment.dict[`${enrollId}`];
    let alias = 'lessonAttempts';
    let index = extractAliasValueFromProcessObject(
      enrollmentProcess.data.root.objects,
      'lessonAttempts'
    ).length;
    let movement = abort ? 'AbortAttempt' : 'CompleteAttempt';
    let fileAlias = 'log';
    if (attemptType === 'exam') {
      alias = 'examAttempts';
      index = extractAliasValueFromProcessObject(
        enrollmentProcess.data.root.objects,
        'examAttempts'
      ).length;
      movement = abort ? 'AbortExamAttempt' : 'CompleteExamAttempt';
      fileAlias = 'examLog';
    }
    yield put(
      execActions.recordAttemptAC({
        enrollId,
        fileAlias,
        alias,
        movement,
        index,
      })
    );
  }
}

function* recordAttempt({ type, payload }) {
  const { enrollId, fileAlias, alias, movement, index } = payload;
  yield delay(1000);
  console.log('lmslog', Executor.getLog(LogLevel.LMS));
  yield put(
    updateEmbeddedProcessDocument_AC({
      id: enrollId,
      document: new File(
        [JSON.stringify(Executor.getLog(LogLevel.LMS))],
        `${enrollId}-${alias}-log.json`,
        {
          type: 'text/json',
        }
      ),
      documentAlias: fileAlias,
      path: alias,
    })
  );
  yield delay(2000);
  yield put(moveEmbeddedProcess_AC(enrollId, movement, `${alias}[${index}]`));
}

function* uiUserSelectWindowDataItem({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  reEmitInMainMonitor(ComposedActions.SelectWindowDataItems, payload);
}

function* uiUserUnselectWindowDataItems({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  reEmitInMainMonitor(ComposedActions.UnselectWindowDataItems, payload);
}

function* uiUserSetAttribute({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { windowId, value } = payload;
  sendToExecutorInMainMonitor(ExecutorActions.UserSetWindowAttribute, {
    ...value,
    window: windowId,
  });
}

const getHookPropertiesfromState = ({
  executorState,
  identifier,
  tracks,
}: {
  executorState: any;
  identifier: string;
  tracks: any;
}) => {
  let latitude = ``;
  let longitude = ``;
  let hookProperties = [];
  const wayPoint = executorState.wayPoints[identifier];
  if (wayPoint) {
    latitude = `${wayPoint.point.latV} ${wayPoint.point.latH}`;
    longitude = `${wayPoint.point.longV} ${wayPoint.point.longH}`;
    hookProperties = wayPoint.hookProperties || [];
  }
  const polygon = executorState.polygons[identifier];
  if (polygon) {
    if (
      polygon.type === PolygonTypes.CIRCLE ||
      polygon.type === PolygonTypes.CIRCULAR_SECTOR
    ) {
      latitude = `${polygon.center.latV} ${polygon.center.latH}`;
      longitude = `${polygon.center.longV} ${polygon.center.longH}`;
      hookProperties = polygon.hookProperties || [];
    }
    if (polygon.type === PolygonTypes.POLYLINE) {
      const selectedPoint = polygon.seqOfPoints.find(
        (point: any) => point.pointLabel === identifier
      );
      if (selectedPoint) {
        latitude = `${selectedPoint.latV} ${selectedPoint.latH}`;
        longitude = `${selectedPoint.longV} ${selectedPoint.longH}`;
        hookProperties = polygon.hookProperties || [];
      }
    }
  }
  if (!polygon) {
    // its a polyline seq point or
    // its a polygon seq point
    Object.keys(executorState.polygons).map((polyKey: string) => {
      const polygonObj = executorState.polygons[polyKey];
      polygonObj.seqOfPoints &&
        polygonObj.seqOfPoints.forEach((polygonPoint: any) => {
          if (polygonPoint.pointLabel === identifier) {
            latitude = `${polygonPoint.latV} ${polygonPoint.latH}`;
            longitude = `${polygonPoint.longV} ${polygonPoint.longH}`;
            hookProperties = polygonObj.hookProperties || [];
          }
        });
    });
  }
  if (tracks && tracks.length > 0) {
    const selectedTrack = tracks.find(
      (track: any) => track.trackNumber === identifier
    );
    if (selectedTrack) {
      const {
        point: { latV, latH, longV, longH },
      } = selectedTrack;
      hookProperties = selectedTrack.hookProperties;
      latitude = `${latV} ${latH}`;
      longitude = `${longV} ${longH}`;
    }
  }
  return {
    latitude,
    longitude,
    hookProperties,
  };
};

function* onPushPrimaryHook({ type, payload }: { type: string; payload: any }) {
  const { actionPayload } = payload;
  const payloadObj = arrayToObjParams(actionPayload);
  const executorState: any = yield select((state: any) => state.executor);
  const tracks: any = yield select((state: any) => state.executor.tracks);
  const { identifier } = payloadObj;
  const { latitude, longitude, hookProperties } = getHookPropertiesfromState({
    executorState,
    identifier,
    tracks,
  });
  if (isDemoMode() || type === ComposedActions.SystemPrimaryHookPoint.id) {
    const { identifier } = payloadObj;
    const internalAction = execActions.internalSetPrimaryHook_AC({
      identifier,
      latitude,
      longitude,
      hookProperties,
    });
    if (type !== ComposedActions.SystemPrimaryHookPoint.id) {
      yield call(showMapPointIndicator, identifier, internalAction);
    } else {
      yield put(internalAction);
      yield readyToTakeNextAction('system primaryHook demo');
    }
  } else {
    yield readyToTakeNextAction(`pushPrimaryHook`);
  }
}

function* onPushSecodaryHook({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { actionPayload } = payload;
  const payloadObj = arrayToObjParams(actionPayload);
  const executorState: any = yield select((state: any) => state.executor);
  const tracks: any = yield select((state: any) => state.executor.tracks);
  const { identifier } = payloadObj;
  const { latitude, longitude, hookProperties } = getHookPropertiesfromState({
    executorState,
    identifier,
    tracks,
  });
  if (isDemoMode() || type === ComposedActions.SystemSecondaryHookPoint.id) {
    const { identifier } = payloadObj;
    const internalAction = execActions.internalSetSecondaryHook_AC({
      identifier,
      latitude,
      longitude,
      hookProperties,
    });
    if (type !== ComposedActions.SystemSecondaryHookPoint.id) {
      yield call(showMapPointIndicator, identifier, internalAction);
    } else {
      yield put(internalAction);
      yield readyToTakeNextAction('system secondaryHook demo');
    }
  } else {
    yield readyToTakeNextAction(`pushSecondaryHook`);
  }
}

function* onPushWindowButton({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  if (isDemoMode()) {
    yield doButtonClick({ type, payload });
  } else {
    //if not in demo mode
    yield readyToTakeNextAction(`pushWindowButton`);
  }
}

function* onPushWindowToggleButton({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { actionPayload } = payload;
  const { window, label, ...rest } = actionPayload;

  if (isDemoMode()) {
    yield doButtonClick({
      type,
      payload: {
        actionPayload: {
          window: window,
          id: Object.keys(rest)[0],
        },
      },
    });
  } else {
    //if not in demo mode
    yield readyToTakeNextAction(`pushWindowToggleButton`);
  }
}

function publishAction(actionObj: any) {
  actionService.publishAction(actionObj);
}

function executorStatusUpdated({
  payload,
  type,
}: {
  payload: any;
  type: string;
}) {
  if (payload.status) {
    localLessonStatus = payload.status;
  }
}

const SendToAllMonitorsActions = [
  touchPanelActions.types.SET_ACTIVE_VABARRAY,
  execActions.types.UPDATE_TSD_ILLUMINATION,
  execActions.types.TOGGLE_BUTTON_CLICK,
  execActions.types.SHOW_MULTIMEDIA_HINT_REVIEW,
  execActions.types.DISMISS_MULTIMEDIA_HINT_REVIEW,
  execActions.types.ADD_MULTIMEDIA_HINT_REVIEW,
];

function* sendToAllMonitorsSaga(actionObj: { type: string; payload: any }) {
  if (actionObj.payload?.broadcasted) {
    return;
  }
  communicatorExecutorActions.postMessage({
    type: actionObj.type,
    payload: {
      ...(actionObj.payload || {}),
      broadcasted: true,
    },
    actionFromExecutor: false,
  });
}
// Handles both ExecutorActions.SystemSetWindowVideo, ExecutorActions.SystemSetWindowLabelImage
// by retrowing the SystyemSetWindowAttributes, that does very similar things
function* onSystemSetWindowVideo({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { actionPayload } = payload;
  const payloadObj = arrayToObjParams(actionPayload);
  const { window, asset, videoContainerId, labelImageId } = payloadObj;
  const { token } = yield select((state: any) => state.authenticate);
  const resources = yield select((state: any) => state.resources);
  const { filename, value } = resources[asset];
  const url = fileResourceUrl(token, value, filename, resources.offlineMode);
  yield put({
    type: ExecutorActions.SystemSetWindowAttributes,
    payload: {
      actionPayload: {
        window: window,
        [type === ExecutorActions.SystemSetWindowVideo
          ? videoContainerId
          : labelImageId]: url,
      },
    },
  });
}

function* onSystemSetWindowTreeItems({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { actionPayload } = payload;
  const payloadObj = arrayToObjParams(actionPayload);
  const { window, asset, treeContainerId } = payloadObj;
  const resources = yield select((state: any) => state.resources);
  console.log({ payloadObj, window, asset }, resources[asset]);
  yield put({
    type: ExecutorActions.SystemSetWindowAttributes,
    payload: {
      actionPayload: {
        window: window,
        [treeContainerId]: JSON.parse(resources[asset]),
      },
    },
  });
}

function* onSetMonitorLayout({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { actionPayload } = payload;

  const payloadObj = arrayToObjParams(actionPayload);
  const { layoutConfiguration } = payloadObj;
  const resource = yield select(
    (state: any) => state.resources[layoutConfiguration]
  );
  yield put(execActions.internalSetMoinitorLayoutConfig_AC(resource));
}

function* onPushWindowButtonCaptureBT({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { actionPayload } = payload;
  const payloadObj = arrayToObjParams(actionPayload);
  if (isDemoMode()) {
    const { captureBT } = payloadObj;
    yield doButtonClick({ type, payload });
    yield put(
      execActions.internalSelectDemoPoint_AC({
        coordinate: captureBT,
        buttonId: payloadObj.id,
      })
    );
    yield delay(2000);
  } else {
    //if not in demo mode
    yield readyToTakeNextAction(`pushWindowButtonCaptureBT`);
  }
}

function* onSetMap({ type, payload }: { type: string; payload: any }) {
  const { actionPayload } = payload;
  const payloadObj = arrayToObjParams(actionPayload);
  const { mapContainerId, monitor, position } = payloadObj;
  const resource = yield select(
    (state: any) => state.resources[mapContainerId]
  );
  yield put(
    execActions.internalSetMap_AC({
      mapContainerId,
      monitor,
      position,
      mapObj: resource,
    })
  );
  // yield put(
  //   execActions.internalSetMap_AC({
  //     mapContainerId,
  //     monitor,
  //     position,
  //     mapObj: {
  //       mapByScale: {
  //         '1': {
  //           mapImage: {
  //             filename: 'Zoom 1 - 10km.png',
  //             filesize: 1312215,
  //             value: 'db:attachment:8561b063-1276-3315-8f9b-cdad65c98b5f',
  //           },
  //           leftUpperCorner: [`1°9'32.552" W`, `37°37'49.658" N`],
  //           rightLowerCorner: [`0°54'46.583" W`, `37°26'59.846" N`],
  //         },
  //         '2': {
  //           mapImage: {
  //             filename: 'Zoom 2 - 2km.png',
  //             filesize: 1311279,
  //             value: 'db:attachment:a37fc971-8535-3856-83ff-ed3c2212e4b7',
  //           },
  //           leftUpperCorner: [`1°9'32.552" W`, `37°37'49.658" N`],
  //           rightLowerCorner: [`0°54'46.583" W`, `37°26'59.846" N`],
  //         },
  //       },
  //     },
  //   })
  // );
}

function* onExecutorDelay({ type, payload }: { type: string; payload: any }) {
  const { time } = payload;
  if (isMasterMonitor) {
    yield delay(time);
    yield readyToTakeNextAction('done with executor delay');
  }
}

function* onUISetPrimaryHook({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { identifier, latitude, longitude, hookProperties } = payload;
  sendToExecutorInMainMonitor(S80ExecutorActions.PrimaryHookPoint, [
    { name: 'identifier', value: identifier },
  ]);
}

function* onUISetSecondaryHook({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { identifier, latitude, longitude, hookProperties } = payload;
  sendToExecutorInMainMonitor(S80ExecutorActions.SecondaryHookPoint, [
    { name: 'identifier', value: identifier },
  ]);
}

function* showIndicator(windowId: string, buttonId: string) {
  const selectorId = !!windowId ? `#${windowId} #${buttonId}` : `#${buttonId}`;
  const pointerBtn = document.querySelector(selectorId);
  if (pointerBtn) {
    console.log('pointer btn');
    const rect = pointerBtn.getBoundingClientRect();
    const x = rect.x + rect.width / 2 - 20;
    const y = rect.y - rect.height / 2;
    yield put(execActions.showIndicator_AC(x, y));
    yield delay(2000);
    clickButtonObj(pointerBtn);
    // if (!!windowId) {
    //   clickButton(windowId, buttonId);
    // } else {
    //   clickButtonObj(pointerBtn);
    // }
  }
}

function* doButtonClickGeneric({ payload }: { payload: any }) {
  const { actionPayload } = payload;
  const { window, id: buttonId } = actionPayload;
  yield call(showIndicator, window, buttonId);
}

function* pressGeneralButtonSwitch({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  console.log('generalbuttonswitch');
  const { actionPayload } = payload;
  const payloadObj = arrayToObjParams(actionPayload);
  const { id, isActive } = payloadObj;
  if (isDemoMode()) {
    if (type === ComposedActions.PressGeneralButtonSwitch.id) {
      yield call(pressGeneralButton, id);
    } else {
      yield call(pressGeneralButton, id, true);
    }
    // yield delay(2000);
    // yield put(execActions.updateGeneralButtonStatus_Ac(id, isActive));
    // yield readyToTakeNextAction();
  } else {
    // yield put(execActions.updateGeneralButtonStatus_Ac(id, isActive));
    yield readyToTakeNextAction(`pressGeneralButtonSwitch`);
  }
}

function* uiPressGeneralButtonSwitch({
  type,
  payload,
}: {
  type: string;
  payload: any;
}) {
  const { id, isActive } = payload;
  if (isDemoMode()) {
    yield takeNextActionInMainMonitor(`uiPressGeneralButtonSwitch demo`);
  } else {
    // send to executor

    if (type === ComposedActions.PressGeneralButtonSwitch.uiAction) {
      sendToExecutorInMainMonitor(ComposedActions.PressGeneralButtonSwitch.id, [
        { name: 'id', value: id },
        {
          name: 'isActive',
          value: isActive,
        },
      ]);
    } else {
      sendToExecutorInMainMonitor(
        ComposedActions.ClickButtonOnReviewAlertsPanel.id,
        [{ name: 'id', value: id }]
      );
    }
  }
}

const onActivateCatizTab = GenericButtonClickBehaviour({
  actionType: ComposedActions.ActivateCatizTab,
  payloadTransformer: (payload: any) => [
    { name: 'tabTitle', value: payload.tabTitle },
  ],
  identifierPathsInExecPayload: {
    buttonId: 'actionPayload.tabTitle',
    window: 'actionPayload.window',
  },
});

//need to change after hermesys is merged into development
// function* onActivateCatizTab({
//   type,
//   payload,
// }: {
//   type: string;
//   payload: any;
// }) {
//   const { actionPayload } = payload;
//   const payloadObj = arrayToObjParams(actionPayload);
//   const { tabTitle } = payloadObj;
//   if (isDemoMode()) {
//     yield call(pressGeneralButton, tabTitle);
//   } else {
//     yield readyToTakeNextAction(`activateCatizTab`);
//   }
// }

// function* onUserActivateCatizTab({
//   type,
//   payload,
// }: {
//   type: string;
//   payload: any;
// }) {
//   const { tabTitle } = payload;
//   if (isDemoMode()) {
//     yield takeNextActionInMainMonitor(`uiActivateCatizTab demo`);
//   } else {
//     sendToExecutorInMainMonitor(ComposedActions.ActivateCatizTab.id, [
//       { name: 'tabTitle', value: tabTitle },
//     ]);
//   }
// }

function* showMenuIndicator(id: string, menu: Array<any>) {
  for (let i = 0; i < menu.length; i++) {
    const result = catiz_menu_bfs(menu[i], id);
    if (result) {
      for (let j = 0; j < result.length; j++) {
        yield call(pressGeneralButton, result[j]);
        yield delay(500);
      }
    }
  }
}

const onPushMenuItem = (menu, nextActionString) =>
  function* ({ type, payload }: { type: string; payload: any }) {
    const { actionPayload } = payload;
    const payloadObj = arrayToObjParams(actionPayload);
    const { menuItemId } = payloadObj;
    if (isDemoMode()) {
      yield call(showMenuIndicator, menuItemId, menu);
    } else {
      yield readyToTakeNextAction(nextActionString);
    }
  };

const onUserPushMenuItem = (action) =>
  function* ({ type, payload }: { type: string; payload: any }) {
    const { menuItemId } = payload;
    if (isDemoMode()) {
      yield takeNextActionInMainMonitor(`${action} demo`);
    } else {
      sendToExecutorInMainMonitor(action, [
        { name: 'menuItemId', value: menuItemId },
      ]);
    }
  };

export const selectUnselectCheckboxPayloadTransformer = (
  actionPayload: any
) => {
  const { window, table } = actionPayload;
  const { tableId, colId, rowNumber, value } = table;
  const buttonId = `${tableId}-${rowNumber}-${convertIdToCssSelectorId(colId)}`;
  return {
    window,
    id: buttonId,
  };
};

const onClickWindowDataItemCellCheckbox = (actionType) =>
  GenericButtonClickBehaviour({
    actionType: actionType,
    payloadTransformer: (payload: any) => payload.actionPayload,
    actionPayloadTransformer: (actionPayload: any) =>
      selectUnselectCheckboxPayloadTransformer(actionPayload),
  });

// function* onClickWindowDataItemCellCheckbox({
//   type,
//   payload,
// }: {
//   type: string;
//   payload: any;
// }) {
//   const { window, table } = payload.actionPayload;
//   const { tableId, colId, rowNumber, value } = table;
//   const buttonId = `${tableId}-${rowNumber}-${convertIdToCssSelectorId(colId)}`;
//   if (isDemoMode()) {
//     yield call(showButtonIndicator, window, buttonId);
//     clickButton(window, buttonId);
//   } else {
//     yield readyToTakeNextAction(`clickWindowDataItemCellCheckbox`);
//   }
// }

// function* onUserClickWindowDataItemCellCheckbox({
//   type,
//   payload,
// }: {
//   type: string;
//   payload: any;
// }) {
//   if (isDemoMode()) {
//     yield takeNextActionInMainMonitor(`uiClickWindowDataItemCellCheckbox demo`);
//   } else {
//     reEmitInMainMonitor(
//       ComposedActions.UserClickWindowDataItemCellCheckbox,
//       payload
//     );
//   }
// }

function* startAttempt() {
  const { enrollId, unit, attemptId, attemptType, mode, subjectId } =
    queryString.parse(window.location.search);
  console.log('[NLMS] startAttempt saga triggered with params', {
    enrollId,
    unit,
    attemptId,
    attemptType,
    mode,
    subjectId,
  });
  yield call(startNlmsAttemptIfPresent as any, {
    enrollId,
    unit,
    subjectId,
    mode,
    attemptType,
  });
  if (attemptType && enrollId) {
    const isExam = attemptType === 'exam';
    //Record only when there is an attemptType parameter in the search params
    const embeddedAlias = isExam ? 'examAttempts' : 'lessonAttempts';
    const executeAlias = isExam ? 'StartExamAttempt' : 'StartAttempt';
    const values: any = {
      [isExam ? 'lessonExam' : 'lesson']: unit,
      ...(subjectId ? { subject: subjectId } : {}),
    };
    if (!isExam) {
      values['executionMode'] = mode;
    }
    const actions = createAddRequest(values, executeAlias);
    const exactaApi = ExactaAPI.getInstance();
    const requests = [
      {
        id: enrollId,
        subscribe: false,
        actions: [
          {
            type: 'embedded',
            value: {
              type: 'create',
              path: embeddedAlias,
              actions,
            },
          },
        ],
      },
    ];
    const { response, error } = yield call(exactaApi.execute, requests);
    yield put(editProcessSuccess_AC({ requests: response.data.requests }));
    if (response) {
      console.log('success', { response });
    } else if (error) {
      console.log('error', { error });
    }
  }
}

function* abortAfterMaxReties() {
  yield put(execActions.finishAttemptAC({ abort: true }));
  yield put(
    execActions.showHint_Ac(
      'You made 3 wrong attempts. You have exceeded maximum number of retries.',
      true
    )
  );
}

function* onMapLoaded() {
  yield takeNextActionInMainMonitor('map loading completed');
}
const ComposedNoPauseActions = Object.values(ComposedActions)
  .filter((action: CustomAction<any>) => action.noPause && !action.noDelay)
  .map((action: CustomAction<any>) => action.id);

const ComposedNoPauseNoDelayActions = Object.values(ComposedActions)
  .filter((action: CustomAction<any>) => action.noPause && action.noDelay)
  .map((action: CustomAction<any>) => action.id);

const actionWatcher = function* () {
  // startTabCommunication();
  yield takeEvery(execActions.types.EXECUTOR_DELAY, onExecutorDelay);
  yield takeEvery(
    [
      execActions.types.EXECUTOR_STATUS_UPDATE,
      execActions.types.START_EXECUTOR,
    ],
    executorStatusUpdated
  );
  yield takeLatest(
    execActions.types.READY_TO_END_LESSON,
    waitForAnimationAndCompleteLesson
  );
  yield takeLatest(execActions.types.START_ATTEMPT, startAttempt);
  yield takeLatest(execActions.types.RECORD_ATTEMPT, recordAttempt);
  yield takeLatest(execActions.types.FINISH_ATTEMPT, finishAttempt);
  yield takeEvery(execActions.types.INTERNAL_MAP_LOADED, onMapLoaded);
  yield takeEvery(
    execActions.types.ABORT_AFTER_MAX_RETRIES,
    abortAfterMaxReties
  );
  yield takeEvery('*', publishAction);
  yield takeEvery(S80ExecutorActions.SetMap, onSetMap);
  yield takeEvery(
    [
      S80ExecutorActions.PrimaryHookPoint,
      ComposedActions.SystemPrimaryHookPoint.id,
    ],
    onPushPrimaryHook
  );
  yield takeEvery(execActions.types.UI_SET_PRIMARY_HOOK, onUISetPrimaryHook);
  yield takeEvery(
    [
      S80ExecutorActions.SecondaryHookPoint,
      ComposedActions.SystemSecondaryHookPoint.id,
    ],
    onPushSecodaryHook
  );
  yield takeEvery(
    execActions.types.UI_SET_SECONDARY_HOOK,
    onUISetSecondaryHook
  );
  yield takeEvery(
    S80ExecutorActions.PushWindowButtonCaptureBT,
    onPushWindowButtonCaptureBT
  );
  yield takeEvery(execActions.types.UI_BT_CAPTURE, onUIBTCapture);
  yield takeEvery(execActions.types.START_EXECUTOR, startExecutorChannel);
  yield takeEvery(execActions.types.START_EXECUTOR, startExecutor);
  yield takeEvery(
    [execActions.types.START_EXECUTOR, execActions.types.LISTEN_IN_TAB],
    startTabCommunication
  );
  yield takeEvery(execActions.types.MULTIMEDIA_OK_CLICK, onMultimediaOkClicked);
  yield takeEvery(
    [...NO_PAUSE_ACTIONS, ...ComposedNoPauseActions],
    takeNextActionWatcher
  );
  yield takeEvery(
    [...NO_PAUSE_NO_DELAY_ACTIONS, ...ComposedNoPauseNoDelayActions],
    takeNextActionImmediately
  );
  // yield takeEvery(ComposedActions.PushWindowButton.id, onPushWindowButton);
  // yield takeEvery(ExecutorActions.PushWindowButton, onPushWindowButton);
  // yield takeEvery(ComposedActions.SetWindowActiveTab.id, doTabClick);
  // yield takeEvery(ExecutorActions.SetWindowActiveTab, doTabClick);
  yield takeEvery(
    S80ExecutorActions.SystemSetMonitorLayout,
    onSetMonitorLayout
  );
  // yield takeEvery(
  //   ComposedActions.SetWindowActiveTab.uiAction,
  //   onUserTabClicked
  // );
  yield takeEvery(
    [
      ComposedActions.SetWindowActiveTab.uiAction,
      ComposedActions.SetWindowActiveTab.id,
    ],
    onTabClickNew
  );
  // yield takeEvery(execActions.types.UI_TAB_CLICKED, onUserTabClicked);
  yield takeEvery(
    [
      ComposedActions.PushWindowButton.uiAction,
      ComposedActions.PushWindowButton.id,
    ],
    onWindowButtonClickedNew
  );
  // yield takeEvery(
  //   execActions.types.UI_WINDOW_BTN_CLICKED,
  //   onWindowButtonClicked
  // );
  yield takeEvery(
    execActions.types.TOUCH_PANEL_BTN_CLICKED,
    onTouchPanelButtonClicked
  );
  yield takeEvery(ExecutorActions.ShowWindow, onWindowShow);
  yield takeEvery(execActions.types.SEND_TO_PARENT, doSendToParent);
  yield takeEvery([...SendToAllMonitorsActions], sendToAllMonitorsSaga);
  yield takeEvery(
    execActions.types.UI_USER_SET_WINDOW_ATTRIBUTE,
    uiUserSetAttribute
  );
  // yield takeEvery(
  //   ComposedActions.SelectWindowDataItems.uiAction,
  //   uiUserSelectWindowDataItem
  // );
  // yield takeEvery(
  //   ComposedActions.UnselectWindowDataItems.uiAction,
  //   uiUserUnselectWindowDataItems
  // );
  yield takeEvery(
    [
      ComposedActions.SelectWindowDataItems.uiAction,
      ComposedActions.SelectWindowDataItems.id,
    ],
    onSelectWindowDataItem(ComposedActions.SelectWindowDataItems)
  );
  yield takeEvery(
    [
      ComposedActions.UnselectWindowDataItems.uiAction,
      ComposedActions.UnselectWindowDataItems.id,
    ],
    onSelectWindowDataItem(ComposedActions.UnselectWindowDataItems)
  );
  yield takeEvery(
    [
      ExecutorActions.SystemSetWindowVideo,
      ExecutorActions.SystemSetWindowLabelImage,
    ],
    onSystemSetWindowVideo
  );
  yield takeEvery(
    ExecutorActions.SystemSetWindowTreeItems,
    onSystemSetWindowTreeItems
  );
  yield takeEvery(
    [
      ComposedActions.PressGeneralButtonSwitch.id,
      ComposedActions.PressGeneralButtonSwitch.uiAction,
    ],
    onGeneralButtonClick
  );
  yield takeEvery(
    [
      ComposedActions.ClickButtonOnReviewAlertsPanel.id,
      ComposedActions.ClickButtonOnReviewAlertsPanel.uiAction,
    ],
    onAlertButtonClick
  );
  // yield takeEvery(
  //   [
  //     ComposedActions.PressGeneralButtonSwitch.id,
  //     ComposedActions.ClickButtonOnReviewAlertsPanel.id,
  //   ],
  //   pressGeneralButtonSwitch
  // );
  // yield takeEvery(
  //   [
  //     ComposedActions.PressGeneralButtonSwitch.uiAction,
  //     ComposedActions.ClickButtonOnReviewAlertsPanel.uiAction,
  //   ],
  //   uiPressGeneralButtonSwitch
  // );
  yield takeEvery(
    [
      ComposedActions.PushWindowToggleButton.id,
      ComposedActions.PushWindowToggleButton.uiAction,
    ],
    onWindowToggleButtonClickedNew(ComposedActions.PushWindowToggleButton)
  );
  yield takeEvery(
    [
      ComposedActions.PushWindowTextToggleButton.id,
      ComposedActions.PushWindowTextToggleButton.uiAction,
    ],
    onWindowToggleButtonClickedNew(ComposedActions.PushWindowTextToggleButton)
  );
  yield takeEvery(
    [
      ComposedActions.SelectWindowDataItemCell.uiAction,
      ComposedActions.SelectWindowDataItemCell.id,
    ],
    onSelectWindowDataItem(ComposedActions.SelectWindowDataItemCell)
  );
  yield takeEvery(
    [
      ComposedActions.UnselectWindowDataItemCell.uiAction,
      ComposedActions.UnselectWindowDataItemCell.id,
    ],
    onSelectWindowDataItem(ComposedActions.UnselectWindowDataItemCell)
  );
  yield takeEvery(
    execActions.types.UPDATE_PENDING_ANIMATIONS,
    updateAnimationsInMainMonitor
  );
  yield takeEvery(
    [
      ComposedActions.ActivateCatizTab.id,
      ComposedActions.ActivateCatizTab.uiAction,
    ],
    onActivateCatizTab
  );
  // yield takeEvery(
  //   ComposedActions.ActivateCatizTab.uiAction,
  //   onUserActivateCatizTab
  // );
  yield takeEvery(
    ComposedActions.PushCatizMenuItem.id,
    onPushMenuItem(MenuItems, ComposedActions.PushCatizMenuItem.id)
  );
  yield takeEvery(
    ComposedActions.PushCatizMenuItem.uiAction,
    onUserPushMenuItem(ComposedActions.PushCatizMenuItem.id)
  );
  yield takeEvery(
    ComposedActions.PushHermesysMenuItem.id,
    onPushMenuItem(HermesysMenu, ComposedActions.PushHermesysMenuItem.id)
  );
  yield takeEvery(
    ComposedActions.PushHermesysMenuItem.uiAction,
    onUserPushMenuItem(ComposedActions.PushHermesysMenuItem.id)
  );
  yield takeEvery(
    [
      ComposedActions.UserClickWindowDataItemCellCheckbox.uiAction,
      ComposedActions.UserClickWindowDataItemCellCheckbox.id,
    ],
    onClickWindowDataItemCellCheckbox(
      ComposedActions.UserClickWindowDataItemCellCheckbox
    )
  );
  // yield takeEvery(
  //   ComposedActions.UserClickWindowDataItemCellCheckbox.id,
  //   onClickWindowDataItemCellCheckbox
  // );
  // yield takeEvery(
  //   ComposedActions.UserClickWindowDataItemCellCheckbox.uiAction,
  //   onUserClickWindowDataItemCellCheckbox
  // );

  yield takeEvery(
    [ExecutorActions.EndOfLesson, execActions.types.END_OF_LESSON],
    onEndLesson
  );
};

export default actionWatcher;
